import type { Content as IContent } from '@bb/sanity.types';
import { ContentRenderer } from '../ContentRenderer';
import { SanityWrapper, Title } from '../SanityWrapper';

export function Content({ block }: { block: IContent }) {
  return (
    <SanityWrapper>
      {!!block.title && <Title title={block.title} />}
      <ContentRenderer content={block.body!} />
    </SanityWrapper>
  );
}
